import React, { useState } from 'react';

export default ({ color, hoverColor, onClick, width, height, Icon }) => {

  const [hovered, setHovered] = useState(false);
  return (
    <div onClick={onClick} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <Icon color={hovered ? hoverColor : color} width={width} height={height} />
    </div>
  );
}
